/** DEPRECATED — the portal's old component set.
 *
 * The app now has one design system in `src/components/ui/`, built on design
 * tokens and theme-aware. Everything here predates it, hardcodes Tailwind
 * palette steps, and does not respond to dark mode.
 *
 * All that remains are the three components still used by
 * `portal/pages/Changes.tsx` and the `formatDate` helper. That page is being
 * rewritten on the `security/cross-org-threading-and-group-auth` branch, so it
 * was deliberately left alone here rather than migrated twice and merged into a
 * conflict. Once that branch lands, migrate it onto `components/ui/`, then move
 * `formatDate` to `lib/format.ts` and delete this file.
 *
 * Do not add anything to this file.
 */
import type { ReactNode } from 'react'

import { STATUS_LABELS } from './types'

const STATUS_STYLES: Record<string, string> = {
  new: 'bg-blue-100 text-blue-800',
  in_progress: 'bg-amber-100 text-amber-800',
  pending_customer: 'bg-purple-100 text-purple-800',
  resolved: 'bg-emerald-100 text-emerald-800',
  closed: 'bg-slate-200 text-slate-700',
  cancelled: 'bg-slate-200 text-slate-500',
}

export function StatusBadge({ status }: { status: string }) {
  return (
    <span
      className={`inline-block rounded-full px-2.5 py-0.5 text-xs font-medium ${
        STATUS_STYLES[status] ?? 'bg-slate-100 text-slate-700'
      }`}
    >
      {STATUS_LABELS[status] ?? status}
    </span>
  )
}

export function Card({ children, className = '' }: { children: ReactNode; className?: string }) {
  return (
    <div className={`rounded-lg border border-slate-200 bg-white p-5 shadow-sm ${className}`}>
      {children}
    </div>
  )
}

export function Spinner({ label = 'Loading' }: { label?: string }) {
  return <p className="py-8 text-sm text-slate-500">{label}…</p>
}

/** A pure helper, and the one thing here worth keeping. */
export function formatDate(value: string | null): string {
  if (!value) return '—'
  return new Date(value).toLocaleString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}
